export const instagramConstants = {
  INSTAGRAM_INIT: '[Instagram] init',
  INSTAGRAM_UPDATE: '[Instagram] Update',
  INSTAGRAM_REMOVE: '[Instagram] Remove'
}
